export const PageLoader = () => (
	<section
		className="fixed left-0 right-0 top-0 bottom-0 z-200 bg-(--background-page) flex items-center justify-center flex-col"
		aria-live="polite"
		aria-busy="true">
		<div className="w-[201px] h-[201px] relative flex items-center justify-center animate-(--animate-fade-in)">
			<img
				alt="Načítání"
				src="/assets/loader/central-loader.svg"
				className="absolute left-0 top-0"
			/>
			<img
				alt=""
				src="/assets/logos/lion.svg"
				className="w-[60px]"
			/>
		</div>
		<span className="fixed h-[201px] flex items-end" />
	</section>
);
